import React, { useEffect } from "react";
import LayoutV2 from "containers/LayoutV2";

export const KhongCoQuyenTruyCap = () => {
  useEffect(() => {
    document.title = "Không có quyền truy cập | Phần mềm quản lý cầm đồ Morman";
  }, []);

  return (
    <LayoutV2>
      <h2 className="text-danger">
        <div className="custom-table-row">
          <div
            className="custom-table-cell text-center red"
            style={{ width: "100%" }}
          >
            Bạn không có quyền truy cập trang này!
          </div>
        </div>
      </h2>
    </LayoutV2>
  );
};
